import React, { useState } from 'react';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { IconKocAilem, BaseCheckIcon } from '@assets/icons';
import Input from '@components/Input';
import RadioGroup from '@components/RadioGroup';
import { useDevice } from '@contexts/device';
import Modal from '@components/Modal/next/Modal';
import GeneralLoader from '@components/ui/GeneralLoader';

import { KocAilemModalSchema } from '../../schemas';
import { Span, Label, Content, Section, Paragraph, Div } from './styled';
import { Button } from '../../common/styled';
export interface KocAilemModalFormData {
  type: string;
  number: string;
}

interface KocAilemModalProps {
  onSubmit: (formData: KocAilemModalFormData) => void;
  onCancel?: () => void;
  isVisible?: boolean;
  isValidated?: boolean;
  hotelListing?: boolean;
  tourCard?: boolean;
  isLoading?: boolean;
}

const Title = (
  <>
    <span>KoçAilem</span>
    <Span>Hesap Doğrulama</Span>
  </>
);

const getLabel = (option: string) => <Label>{option}</Label>;
const getValue = (option: string, index?: number) => `${option}#${index}`;

const options = ['T.C Kimlik No', 'KoçAilem No', 'KoçAilem Kart No'];
const headerMediaQuery = '@media screen and (max-width: 465px)';

const KocAilem = ({
  onSubmit,
  onCancel,
  isValidated = false,
  hotelListing,
  tourCard,
  isLoading,
  ...rest
}: KocAilemModalProps) => {
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm<KocAilemModalFormData>({
    defaultValues: {
      type: 'T.C Kimlik No#0',
      number: '',
    },
    resolver: yupResolver(KocAilemModalSchema),
  });

  const getSelectionLabel = (selectedId) => {
    switch (selectedId) {
      case 0:
        return 'T.C Kimlik Numaranız';
      case 1:
        return 'KoçAilem Numaranız';
      case 2:
        return 'KoçAilem Kart Numaranız';
      default:
        return '';
    }
  };

  const [selected, setSelected] = useState(0);
  const label = getSelectionLabel(selected);
  const maxLength = selected === 2 ? 16 : 11;
  const { isDesktop } = useDevice();
  return isLoading ? (
    <>
      <GeneralLoader shouldScroll={false} />
    </>
  ) : (
    <Modal
      width={550}
      padding='40px'
      title={Title}
      borderRadius={8}
      headerMediaQuery={headerMediaQuery}
      onCancel={onCancel}
      zIndex={1001}
      {...rest}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Content>
          <IconKocAilem width={46} />
          <Section>
            {hotelListing ? (
              <Paragraph>
                İndirimli otel seçerek devam etmek için{' '}
                <strong>T.C Kimlik No</strong>,<strong> KoçAilem No</strong>{' '}
                veya <strong> KoçAilem Kart No</strong> ile hesabınızı
                doğrulayınız.
              </Paragraph>
            ) : tourCard ? (
              <Paragraph>
                İndirimli Tur paketini seçerek devam etmek için{' '}
                <strong>T.C Kimlik No</strong>,<strong> KoçAilem No</strong>{' '}
                veya <strong> KoçAilem Kart No</strong> ile hesabınızı
                doğrulayınız.
              </Paragraph>
            ) : (
              <Paragraph>
                İndirimli otel odasını seçerek devam etmek için{' '}
                <strong>T.C Kimlik No</strong>,<strong> KoçAilem No</strong>{' '}
                veya <strong> KoçAilem Kart No</strong> ile hesabınızı
                doğrulayınız.
              </Paragraph>
            )}
          </Section>
          {isDesktop ? (
            <Div>
              <Controller
                control={control}
                name='type'
                render={({ field }) => (
                  <RadioGroup
                    options={options}
                    direction='row'
                    selectedIndex={0}
                    getLabel={getLabel}
                    getValue={getValue}
                    {...field}
                    onChange={(value) => {
                      const [, number = ''] = value.split('#');
                      setSelected(Number(number));
                      field.onChange(value);
                      setValue('type', value);
                    }}
                  />
                )}
              />
            </Div>
          ) : (
            <Controller
              control={control}
              name='type'
              render={({ field }) => (
                <RadioGroup
                  options={options}
                  direction='column'
                  selectedIndex={0}
                  getLabel={getLabel}
                  getValue={getValue}
                  {...field}
                  onChange={(value) => {
                    const [, number = ''] = value.split('#');
                    setSelected(Number(number));
                    field.onChange(value);
                    setValue('type', value);
                  }}
                />
              )}
            />
          )}

          <Section>
            <Controller
              control={control}
              name='number'
              render={({ field }) => (
                <Input
                  label={label}
                  maxLength={maxLength}
                  type='text'
                  onKeyPress={(e) => {
                    if (!/^([0-9])$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  {...field}
                  error={Boolean(errors.number)}
                />
              )}
            />
            <Button
              disabled={isSubmitting}
              outline
              type='submit'
              isValid={isValidated}
              hasHover={false}
            >
              <span>{!isValidated ? 'Doğrula' : 'Doğrulandı'}</span>
              <BaseCheckIcon width={24} height={24} />
            </Button>
          </Section>
        </Content>
      </form>
    </Modal>
  );
};

export default KocAilem;
